

export default function NotFound404() {

    return (
        <>
            <div className="divFondoTransparencia">
                <img src="https://www.medellin.gov.co/error/MedellinTodosPorLaVidaLogo_15.jpg" alt="Medellín todos por la vida" title="Medellín todos por la Vida" />
            </div>
            <div className="divMensaje">
                <div className="divTitulo">Error 404 - Página no encontrada</div>
                <div className="divTexto">La página que intenta ver no se encuentra disponible.</div>
            </div>
        </>
    )
}